package diana.soleil.design.iraniancanadienbazzar.core.data.di

import diana.soleil.design.iraniancanadienbazzar.core.firebase.AuthService
import diana.soleil.design.iraniancanadienbazzar.core.data.AdminRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.DealsRepository
import diana.soleil.design.iraniancanadienbazzar.core.model.LocalizedText
import diana.soleil.design.iraniancanadienbazzar.core.model.Deal
import diana.soleil.design.iraniancanadienbazzar.core.data.BlockRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ChannelRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ChatRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.EventRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.NewsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ListingMetricsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.OwnerRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.MarketplaceRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.OrderRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ProductRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ListingRequestRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ReportRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.TicketRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.NotificationRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.PostRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.FollowRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.GemsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.ReviewRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.BusinessRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.CategoryRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.UserProfileRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeAdminRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.MockDataController
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeDealsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeBlockRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeChannelRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeChatRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeEventRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeNewsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeListingMetricsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeOwnerRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeMarketplaceRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeOrderRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeProductRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeReportRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeListingRequestRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeTicketRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeNotificationRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakePostRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeFollowRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeGemsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeReviewRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeAuthService
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeBusinessRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeCategoryRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.FakeUserProfileRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.fake.MockScenarios
import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import diana.soleil.design.iraniancanadienbazzar.core.data.CartController
import diana.soleil.design.iraniancanadienbazzar.core.data.BusinessDraftStore
import diana.soleil.design.iraniancanadienbazzar.core.data.CityController
import diana.soleil.design.iraniancanadienbazzar.core.data.FavoritesController
import diana.soleil.design.iraniancanadienbazzar.core.data.InterestsController
import diana.soleil.design.iraniancanadienbazzar.core.data.SavedItemsController
import diana.soleil.design.iraniancanadienbazzar.core.data.SavedNewsController
import diana.soleil.design.iraniancanadienbazzar.core.data.AppGatesConfig
import diana.soleil.design.iraniancanadienbazzar.core.data.FeatureFlags
import diana.soleil.design.iraniancanadienbazzar.core.data.GemsConfig
import diana.soleil.design.iraniancanadienbazzar.core.data.GemsSavedController
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.data.SunsetConfig
import diana.soleil.design.iraniancanadienbazzar.core.data.SponsorshipConfig
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreAdminRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreBlockRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreChannelRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreChatRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreEventRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreNewsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreListingMetricsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreOwnerRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreMarketplaceRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreOrderRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreProductRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreReportRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreDealsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreListingRequestRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreTicketRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreNotificationRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestorePostRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreFollowRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreGemsRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreReviewRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreBusinessRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreCategoryRepository
import diana.soleil.design.iraniancanadienbazzar.core.data.firestore.FirestoreUserProfileRepository
import org.koin.dsl.module

/**
 * Repository bindings. **Default = in-memory fakes** so the app runs without Firebase init / seeded
 * data. Swap to [firestoreDataModule] in the app composition root (`:shared` AppModules) once each
 * platform's Firebase is initialized and dev Firestore is seeded with `approved`, object-form listings.
 * Both modules depend on `coreFirebaseModule` (for `FirebaseServices`).
 */
val coreDataModule = module {
    // Mock mode swaps the auth seam too, otherwise every isGuest-gated surface (the Messages tab
    // most visibly) stays locked and QA cannot exercise it — see FakeAuthService.
    single<AuthService> { FakeAuthService() }
    single<BusinessRepository> { FakeBusinessRepository() }
    single<CategoryRepository> { FakeCategoryRepository() }
    single<UserProfileRepository> { FakeUserProfileRepository() }
    single<AdminRepository> { FakeAdminRepository() }
    single<DealsRepository> { FakeDealsRepository() }
    single<ReviewRepository> { FakeReviewRepository() }
    single<FollowRepository> { FakeFollowRepository() }
    single<BlockRepository> { FakeBlockRepository() }
    single<ChatRepository> { FakeChatRepository() }
    single<ChannelRepository> { FakeChannelRepository() }
    single<OwnerRepository> { FakeOwnerRepository() }
    single<PostRepository> { FakePostRepository() }
    single<MarketplaceRepository> { FakeMarketplaceRepository() }
    single<EventRepository> { FakeEventRepository() }
    single<NewsRepository> { FakeNewsRepository() }
    single<NotificationRepository> { FakeNotificationRepository() }
    single<ProductRepository> { FakeProductRepository() }
    single<OrderRepository> { FakeOrderRepository() }
    single<TicketRepository> { FakeTicketRepository() }
    single<ReportRepository> { FakeReportRepository() }
    single<ListingRequestRepository> { FakeListingRequestRepository() }
    single<ListingMetricsRepository> { FakeListingMetricsRepository() }
    single<GemsRepository> { FakeGemsRepository() }
}

/**
 * Debug-only **mock-data mode** bindings (Developer Menu → "Populate mock data"): the same fakes as
 * [coreDataModule] but seeded with the full [MockScenarios] QA world and stateful, so every flow —
 * chat, orders, tickets, feed, admin queues, dashboard analytics, every notification type — is
 * exercisable end-to-end with **zero backend traffic**. Selected by the composition root while
 * `MockDataController.enabled`; dropping the graph (Clear mock data) discards all of it.
 */
val mockDataModule = module {
    // Store-screenshot capture drops the mock stock photos so only artwork we own reaches a listing
    // image (the app renders its category emblem + gradient instead). See MockScenarios.photoFree*.
    val capture = MockDataController.screenshotMode.value
    single<BusinessRepository> {
        FakeBusinessRepository(if (capture) MockScenarios.photoFreeBusinesses() else MockScenarios.businesses)
    }
    single<CategoryRepository> { FakeCategoryRepository() }
    single<UserProfileRepository> { FakeUserProfileRepository(seedProfile = MockScenarios.profile) }
    single<AdminRepository> {
        FakeAdminRepository(
            seedPendingBusinesses = listOf(MockScenarios.pendingBusiness),
            seedReports = MockScenarios.openReports,
            seedPendingEvents = MockScenarios.pendingEvents,
            seedClaims = MockScenarios.claims,
            seedUsers = MockScenarios.userAccounts,
            currentUid = MockScenarios.MOCK_UID,
        )
    }
    // Shared concrete instance so owner replies land on the same review state the public screens show.
    single { FakeReviewRepository(MockScenarios.reviews, MockScenarios.MOCK_UID, MockScenarios.MOCK_NAME) }
    single<ReviewRepository> { get<FakeReviewRepository>() }
    single<FollowRepository> { FakeFollowRepository() }
    single<BlockRepository> { FakeBlockRepository(MockScenarios.blockedUsers) }
    single<ChatRepository> {
        FakeChatRepository(
            seedConversations = MockScenarios.conversations,
            seedMessages = MockScenarios.messages,
            currentUid = MockScenarios.MOCK_UID,
            seedPeople = MockScenarios.people,
        )
    }
    single<ChannelRepository> { FakeChannelRepository(currentUid = MockScenarios.MOCK_UID) }
    single<OwnerRepository> {
        FakeOwnerRepository(
            owned = if (capture) MockScenarios.photoFreeOwned()
            else listOf(MockScenarios.ownedBusiness, MockScenarios.realtorBusiness),
            reviewRepository = get<FakeReviewRepository>(),
        )
    }
    single<PostRepository> {
        FakePostRepository(
            if (capture) MockScenarios.photoFreePosts() else MockScenarios.posts,
            MockScenarios.comments,
            MockScenarios.MOCK_UID,
            MockScenarios.MOCK_NAME,
        )
    }
    single<MarketplaceRepository> {
        FakeMarketplaceRepository(
            if (capture) MockScenarios.photoFreeMarketplaceItems() else MockScenarios.marketplaceItems,
            MockScenarios.MOCK_UID,
            MockScenarios.MOCK_NAME,
        )
    }
    single<EventRepository> {
        FakeEventRepository(if (capture) MockScenarios.photoFreeEvents() else MockScenarios.events)
    }
    single<NewsRepository> {
        FakeNewsRepository(if (capture) MockScenarios.photoFreeNews() else MockScenarios.news)
    }
    single<NotificationRepository> { FakeNotificationRepository(MockScenarios.notifications) }
    single<ProductRepository> {
        FakeProductRepository(if (capture) MockScenarios.photoFreeProducts() else MockScenarios.products)
    }
    single<OrderRepository> { FakeOrderRepository(MockScenarios.orders) }
    single<TicketRepository> {
        FakeTicketRepository(
            types = MockScenarios.ticketTypes,
            seedTickets = MockScenarios.tickets,
            eventLookup = { id -> MockScenarios.events.firstOrNull { it.id == id } },
        )
    }
    single<ReportRepository> { FakeReportRepository() }
    single<ListingRequestRepository> { FakeListingRequestRepository() }
    single<ListingMetricsRepository> {
        FakeListingMetricsRepository(MockScenarios.listingCounters, MockScenarios.dailyCounters)
    }
    single<GemsRepository> { FakeGemsRepository() }
    // Home's deals rail. This binding was missing until 2026-09-10: "Populate mock data" then
    // crashed the app on the first Home composition (Koin NoDefinitionFoundException for
    // DealsRepository) — mock mode was unusable and nobody noticed because nothing exercised it.
    // MockDataModuleTest now resolves every repository the live module binds.
    single<DealsRepository> {
        FakeDealsRepository(
            listOf(
                Deal(
                    id = "mock-deal-1",
                    businessId = MockScenarios.ownedBusiness.id,
                    businessName = MockScenarios.ownedBusiness.name,
                    title = LocalizedText(en = "20% off catering this month", fa = "۲۰٪ تخفیف کترینگ این ماه"),
                    details = LocalizedText(en = "Mention Mahaleh when you order."),
                    endsAtMillis = MOCK_FAR_FUTURE_MILLIS,
                ),
                Deal(
                    id = "mock-deal-2",
                    businessId = MockScenarios.realtorBusiness.id,
                    businessName = MockScenarios.realtorBusiness.name,
                    title = LocalizedText(en = "Free home evaluation", fr = "Évaluation gratuite"),
                    endsAtMillis = MOCK_FAR_FUTURE_MILLIS,
                ),
            ),
        )
    }
}

/**
 * Three weeks out: long enough that a demo deal never expires while the mock graph lives, short
 * enough to read like a real offer. A fixed far-future date (2100-01-01) made the deal card say
 * "Ends in 26771 days", which is nonsense on screen and unusable in a store screenshot.
 */
private val MOCK_FAR_FUTURE_MILLIS: Long
    get() = kotlin.time.Clock.System.now().toEpochMilliseconds() + 21L * 24 * 60 * 60 * 1000

/** Live Cloud Firestore (GitLive) repositories. Activate by replacing [coreDataModule] in AppModules. */
val firestoreDataModule = module {
    single<BusinessRepository> { FirestoreBusinessRepository(get(), get()) }
    single<CategoryRepository> { FirestoreCategoryRepository(get()) }
    single<UserProfileRepository> { FirestoreUserProfileRepository(get(), get()) }
    single<AdminRepository> { FirestoreAdminRepository(get(), get()) }
    single<ReviewRepository> { FirestoreReviewRepository(get(), get()) }
    single<FollowRepository> { FirestoreFollowRepository(get(), get()) }
    single<BlockRepository> { FirestoreBlockRepository(get(), get()) }
    single<ChatRepository> { FirestoreChatRepository(get(), get()) }
    single<ChannelRepository> { FirestoreChannelRepository(get(), get()) }
    single<OwnerRepository> { FirestoreOwnerRepository(get(), get()) }
    single<PostRepository> { FirestorePostRepository(get(), get()) }
    single<MarketplaceRepository> { FirestoreMarketplaceRepository(get(), get()) }
    single<EventRepository> { FirestoreEventRepository(get(), get()) }
    single<NewsRepository> { FirestoreNewsRepository(get()) }
    single<NotificationRepository> { FirestoreNotificationRepository(get(), get()) }
    single<ProductRepository> { FirestoreProductRepository(get()) }
    single<OrderRepository> { FirestoreOrderRepository(get(), get()) }
    single<TicketRepository> { FirestoreTicketRepository(get(), get()) }
    single<ReportRepository> { FirestoreReportRepository(get(), get()) }
    single<ListingRequestRepository> { FirestoreListingRequestRepository(get()) }
    single<DealsRepository> { FirestoreDealsRepository(get(), get()) }
    single<ListingMetricsRepository> { FirestoreListingMetricsRepository(get()) }
    single<GemsRepository> { FirestoreGemsRepository(get(), get()) }
}

/** App-scoped data state independent of the fake/Firestore choice (prefs + active metro). Always included. */
val appStateModule = module {
    single { AppPreferences() }
    single { BusinessDraftStore(get()) }
    single { CityController(get()) }
    single { InterestsController(get()) }
    single { FavoritesController(get()) }
    single { SavedItemsController(get()) }
    single { SavedNewsController(get()) }
    single { SponsorshipConfig() }
    single { CartController(get()) }
    single { ShareConfig() }
    single { FeatureFlags() }
    single { SunsetConfig() }
    single { AppGatesConfig() }
    single { GemsConfig() }
    single { GemsSavedController(get(), get()) }
}
